import * as z from "zod";

export const getSyncDeliveryProfileProductMetafieldsNowStatus = {
  name: "getSyncDeliveryProfileProductMetafieldsNowStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ isRunning: z.boolean() }),
};
